export const appBar = (scrolled) => ({
    background: scrolled ? 'rgba(1, 1, 52, 0.78)' : 'transparent',
    backdropFilter: scrolled ? 'saturate(160%) blur(14px)' : 'none',
    WebkitBackdropFilter: scrolled ? 'saturate(160%) blur(14px)' : 'none',
    borderBottom: '1px solid',
    borderColor: scrolled ? 'rgba(187, 188, 188, 0.12)' : 'transparent',
    boxShadow: 'none',
    transition: 'background 0.25s ease, backdrop-filter 0.25s ease, border-color 0.25s ease',
});

export const toolbar = {
    maxWidth: '1280px',
    width: '100%',
    mx: 'auto',
    px: { xs: 2, md: 4 },
    py: '16px',
    minHeight: 'unset',
    justifyContent: 'space-between',
};

export const logoButton = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    p: 0,
    position: 'relative',
    height: { xs: 40, md: 48 },
    display: 'flex',
    alignItems: 'center',
};

export const logoFull = (scrolled) => ({
    height: { xs: 36, md: 44 },
    width: 'auto',
    position: scrolled ? 'absolute' : 'relative',
    opacity: scrolled ? 0 : 1,
    transform: scrolled ? 'translateX(-4px)' : 'translateX(0)',
    transition: 'opacity 0.25s ease, transform 0.35s ease',
    pointerEvents: 'none',
});

export const logoSymbol = (scrolled) => ({
    height: { xs: 36, md: 40 },
    width: 'auto',
    position: scrolled ? 'relative' : 'absolute',
    opacity: scrolled ? 1 : 0,
    transform: scrolled ? 'translateX(0)' : 'translateX(4px)',
    transition: 'opacity 0.25s ease, transform 0.35s ease',
    pointerEvents: 'none',
});

export const nav = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
};

export const navButton = {
    fontSize: '16px',
    padding: '9.6px 17.6px',
};

export const navLabelFull = {
    display: { xs: 'none', md: 'inline' },
};

export const navLabelShort = {
    display: { xs: 'inline', md: 'none' },
};
